/**
 * Created by Z179603 on 2/29/2016.
 */
angular.module('cvsApp').factory('validation', function() {
    var validation={};
    var validationRulesObj={};
    var callbackSection={
        "question":false,
        ind:false
    };
    var messageObj = {
        "Message1": "Your insurance carrier does not allow prescriptions to be sent outside your home state. Please choose an address within your state.",
        "Message2": "Because of state law, we can't ship Specialty medications for you to pick up at a store within Oklahoma. You can have it shipped directly to you, or to a store in a nearby state.",
        "Message3": "We're sorry but the state where your primary pharmacy is located doesn't allow prescriptions to be shipped to a store. We can only ship them to you. We apologize for any inconvenience.",
        "Message4": "Your insurance carrier does not allow prescriptions to be sent to  pharmacies outside of your home state. Please search for a store in your state or have your order sent directly to you.",
        "Message5":"Your insurance carrier does not allow prescriptions to be sent outside your home state. Please choose an address within your state.",
        "callBackMsg1":"You previously indicated that you would like to speak to a pharmacist.Please provide the best number and time of day to reach you.",
        "callBackMsg2":"We will need to call you before your order is processed. Please provide the best number and time of day to reach you."
    };


        validation.homeState = function() {
            return validationRulesObj.homeState;
        };
        validation.setHomeState=function(allAddress){
            var homeAddress=this.getPatientPrimaryAddress(allAddress,'Primary Home');
            validationRulesObj.homeState= homeAddress.state;
        };
        validation.checkValidation=function(Address){
            return "ErrorMessage";
        };
        validation.setValidationRules=function(validationResponse){
            validationRulesObj.validationRule=validationResponse;
            this.setHomeStateApplicable();
            this.setValidationRuleState();
        };

        validation.noRulesApply =function(){
             /*validationRulesObj.validationRule.allowShipToOtherStates="true";
             validationRulesObj.validationRule.shipToStoreForbiddenStates.state=[];*/
            validationRulesObj.isHomeStateApplicable=false;
            validationRulesObj.validationRuleState=[];
        };

        validation.setHomeStateApplicable= function(){
            if(validationRulesObj.validationRule && validationRulesObj.validationRule.allowShipToOtherStates && validationRulesObj.validationRule.allowShipToOtherStates==="false"){
                return validationRulesObj.isHomeStateApplicable=true;
            }else{
                return validationRulesObj.isHomeStateApplicable=false;
            }};
        validation.setValidationRuleState=function(){
            /**
             * SMP 77 07/31/2017 - SP
             * Modified code to support single forbidden state.
             */
            if(validationRulesObj.validationRule && validationRulesObj.validationRule.shipToStoreForbiddenStates && validationRulesObj.validationRule.shipToStoreForbiddenStates.state
                ){
                if(Array.isArray(validationRulesObj.validationRule.shipToStoreForbiddenStates.state)){
                return validationRulesObj.validationRuleState=validationRulesObj.validationRule.shipToStoreForbiddenStates.state;
                }
                else{
                    validationRulesObj.validationRuleState = [];
                    validationRulesObj.validationRuleState.push(validationRulesObj.validationRule.shipToStoreForbiddenStates.state);
                    return validationRulesObj.validationRuleState;
                }

            }else{
                return validationRulesObj.validationRuleState=[];
            }
        };
        validation.isHomeStateApplicable= function(){
           return validationRulesObj.isHomeStateApplicable;
        };

        validation.validationRuleState=function(){
            return validationRulesObj.validationRuleState;
        };

        validation.getPatientPrimaryAddress =function(allAddress,addressType){

        if(allAddress){
            var data = allAddress;

            if(_.isArray(data)){
                for(var items in data){
                    if(data[items].addressType == addressType){
                        return data[items];
                    }
                }
            }else{
                if(data.addressType==addressType){
                    return data;
                }
            }
            return {};
        }
    };

    validation.validateAddress=function(address,type){
        var errorMessage="";
        var homeState=this.homeState();
        var restrictedStateList=this.validationRuleState();
        switch(type) {
            case "shipToHome":
                if(this.isHomeStateApplicable() && address && homeState  && homeState!==address.state ){
                    errorMessage=this.getErrorMessage("message1");
                }
                break;
            case "shipToStore":
                var restrictedStateInd=false;
                if(restrictedStateList && restrictedStateList.length>0 && address && address.state){
                    for(i=0;i<restrictedStateList.length;i++){
                        if(address.state===restrictedStateList[i]){
                            errorMessage=this.getErrorMessage("message2");
                            restrictedStateInd=true;
                        }
                    }
                }
                if(address && this.homeState()){
                	var storeStateMatch = restrictedStateInd;
                	var homeStateMatch = restrictedStateList.contains(this.homeState());
                	 if(!this.isHomeStateApplicable()){
                     	if(storeStateMatch){
                     		if(homeStateMatch){
                     			errorMessage=this.getErrorMessage("message3");
                     		}else{
                     			errorMessage=this.getErrorMessage("message2");
                     		}
                     	}

                     }else{
                    	 if(storeStateMatch){
                    		 if(homeStateMatch){
                    			 errorMessage=this.getErrorMessage("message3");
                    		 }else{
                    			 errorMessage=this.getErrorMessage("message2");
                    		 }

                    	 }else {
                    		 if(homeStateMatch){
                        		 errorMessage=this.getErrorMessage("message2");
                        	 }else{
                        		 if(this.homeState() !== address.state){
                        			 errorMessage=this.getErrorMessage("message4");
                        		 }

                        	 }
                    	 }
                     }
                }
                break;
           default:
                errorMessage="";
        }
        return errorMessage;

    };

    Array.prototype.contains = function(obj) {
        var i = this.length;
        while (i--) {
            if (this[i] == obj) {
                return true;
            }
        }
        return false;
    };

    validation.getErrorMessage = function (condition) {
        /*var messageObj = {
            "Message1": "Message 1:shipToHome -Your insurance carrier does not allow prescriptions to be sent outside your home state. Please choose an address within your state.",
            "Message2": "Message 2:shipToStore state restricted-We're sorry but the state you selected doesn't allow prescriptions to be shipped to a store. We can only ship them to you. We apologize for any inconvenience.",
            "Message3": "Message 3:shipToStore home state-We're sorry but the state where your primary pharmacy is located doesn't allow prescriptions to be shipped to a store. We can only ship them to you. We apologize for any inconvenience.",
            "Message4": "Message 4:-shipToStore both Your insurance carrier does not allow prescriptions to be sent to  pharmacies outside of your home state. Please search for a store in your state or have your order sent directly to you."

        };*/
        switch(condition) {
            case "message1":
                return messageObj.Message1;
            case "message2":
                return messageObj.Message2;
            case "message3":
                return messageObj.Message3;
            case "message4":
                return messageObj.Message4;
            default:return ""
        }

    };

    validation.validateStorePickUpAddress = function(storePickupAddress){
        var address={};
        if(storePickupAddress){
            address={
                addressLine1:storePickupAddress.content.properties.AddressLine.__text,
                city:storePickupAddress.content.properties.Locality.__text,
                state:storePickupAddress.content.properties.AdminDistrict.__text,
                "zipCode":storePickupAddress.content.properties.PostalCode.__text
            }
        }else{

        }
        return validation.validateAddress(address,"shipToStore");
    };
    validation.setMessage =function(content){
        /*var messageObj = {
         "Message1": "Message 1:shipToHome -Your insurance carrier does not allow prescriptions to be sent outside your home state. Please choose an address within your state.",
         "Message2": "Message 2:shipToStore state restricted-We're sorry but the state you selected doesn't allow prescriptions to be shipped to a store. We can only ship them to you. We apologize for any inconvenience.",
         "Message3": "Message 3:shipToStore home state-We're sorry but the state where your primary pharmacy is located doesn't allow prescriptions to be shipped to a store. We can only ship them to you. We apologize for any inconvenience.",
         "Message4": "Message 4:-shipToStore both Your insurance carrier does not allow prescriptions to be sent to  pharmacies outside of your home state. Please search for a store in your state or have your order sent directly to you."

         };*/
        if(content.refill_checkout){
            messageObj.Message1=content.refill_checkout.rfr_cannot_ship_outofstate?content.refill_checkout.rfr_cannot_ship_outofstate:messageObj.Message1;
            messageObj.Message2=content.refill_checkout.rfr_disallow_states_msg?content.refill_checkout.rfr_disallow_states_msg:messageObj.Message2;
            messageObj.Message3=content.refill_checkout.rfr_disallow_CVS_states_msg?content.refill_checkout.rfr_disallow_CVS_states_msg:messageObj.Message3;
            messageObj.Message4=content.refill_checkout.rfr_choosestore_withinstate?content.refill_checkout.rfr_choosestore_withinstate:messageObj.Message4;
            messageObj.Message5=content.refill_checkout.rfr_choose_address_within_state;
            messageObj.callBackMsg1=content.refill_checkout.rfr_contact_pharmacist;
            messageObj.callBackMsg2=content.refill_checkout.rfr_callbefore_orderprocessed;
        }
    };

    validation.setCallBackMessage =function(msg1,msg2){
        messageObj.callBackMsg1=msg1;
        messageObj.callBackMsg2=msg2;
    };

    validation.setCallbackInd=function(questInd,callbackInd){
        if(questInd){
            callbackSection.question=questInd;
        }
        callbackSection.ind=callbackInd;

    };

    validation.resetCallBackInd=function(){
        callbackSection.question=false;
        callbackSection.ind=false;

    };

    validation.getCallBackInd=function(){
        return callbackSection.ind;
    };

    validation.getCallBackMessage =function(){
        if(callbackSection.question){
          return messageObj.callBackMsg1;
        }else{
            return messageObj.callBackMsg2;
        }
    };
    return validation;
});